import { useState } from "react";
import { submitDemoRequest } from "../lib/demo";
import { Button } from "../components/ui/Button";

const empty = { full_name: "", email: "", company: "", job_title: "", phone: "", country: "", industry: "", sites: "", message: "" };

const fields = [
  ["full_name", "Full name", "text", true],
  ["email", "Business email", "email", true],
  ["company", "Company", "text", true],
  ["job_title", "Job title", "text", false],
  ["phone", "Phone", "tel", false],
  ["country", "Country", "text", false],
  ["industry", "Industry", "text", false],
  ["sites", "Number of sites", "text", false],
];

export function RequestDemo() {
  const [form, setForm] = useState(empty);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(event) {
    event.preventDefault();
    setError("");
    setNotice("");
    if (!form.full_name.trim() || !form.email.includes("@") || !form.company.trim()) {
      setError("Full name, business email, and company are required.");
      return;
    }
    setBusy(true);
    const result = await submitDemoRequest(form);
    setBusy(false);
    if (!result.ok) setError(result.error);
    else {
      setNotice(result.message);
      setForm(empty);
    }
  }

  return (
    <section id="demo" className="scroll-mt-20 px-5 py-16">
      <div className="mx-auto max-w-xl">
        <h2 className="text-4xl font-bold">Request a demo</h2>
        <p className="mt-3 text-slate-600">Tell Globotech about the facility. This stores a request. It does not book a salesperson or claim a certification.</p>
        <form onSubmit={submit} className="mt-8 grid gap-4">
          {fields.map(([name, label, type, required]) => (
            <label key={name} className="grid gap-1 text-sm font-semibold">
              {label}
              <input className="rounded border border-slate-300 px-3 py-2 font-normal" type={type} required={required} value={form[name]} onChange={(event) => setForm({ ...form, [name]: event.target.value })} />
            </label>
          ))}
          <label className="grid gap-1 text-sm font-semibold">
            Message
            <textarea className="rounded border border-slate-300 px-3 py-2 font-normal" rows="4" value={form.message} onChange={(event) => setForm({ ...form, message: event.target.value })} />
          </label>
          {error ? <p className="text-sm text-rose-700" role="alert">{error}</p> : null}
          {notice ? <p className="text-sm text-sky-800" role="status">{notice}</p> : null}
          <Button className="w-fit" onClick={undefined} {...{ type: "submit", disabled: busy }}>{busy ? "Sending" : "Submit request"}</Button>
        </form>
      </div>
    </section>
  );
}
